type GhlHelpModalProps = {
  open: boolean;
  onClose: () => void;
};

export function GhlHelpModal({ open, onClose }: GhlHelpModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 p-6 space-y-4 text-sm"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="font-semibold text-gray-900 text-base">How GHL Connections work</h3>
        <div className="space-y-3 text-gray-700 text-xs leading-relaxed">
          <p>
            <strong>What is a Connection?</strong> Each connection represents one GHL Sub-Account (also called a
            Location). Most orgs have exactly one. Multiple connections are for orgs that operate multiple GHL
            sub-accounts.
          </p>
          <p>
            <strong>GHL Sub-Account ID</strong> — Find this in GHL inside the sub-account under Settings &rarr;
            Business Info. It also appears in the URL:{" "}
            <code className="bg-gray-100 px-1 rounded">app.gohighlevel.com/location/&lt;ID&gt;/...</code>
          </p>
          <p>
            <strong>API Key</strong> — A Private Integration key created inside the sub-account at Settings &rarr;
            Integrations &rarr; Private Integrations. Required scopes:{" "}
            <em>
              Opportunities (Read), Contacts (Read), Locations (locations.readonly), Social Planner — Posts (Read) and
              Accounts (Read) for Ads Assistant feed sync
            </em>
            .
          </p>
          <p>
            <strong>Rotating the API key</strong> — If you regenerate the key in GHL (e.g. after adding new scopes),
            use the <strong>Update key</strong> button on the connection card — <em>not</em> &ldquo;Add GHL
            connection&rdquo;. Adding a new connection creates a duplicate record.
          </p>
          <p>
            <strong>Pipelines</strong> — After adding a connection, click <strong>+ Add pipeline</strong> to link a
            specific GHL pipeline for CRM hygiene tracking and lead sync.
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="w-full mt-2 px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm hover:bg-indigo-700"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
